import React from 'react';

class Image extends React.Component {

  render() {
    if(!this.props.image) {
      return null
    } else {
      return (
        <div className={`brew-image ${ !this.props.image.attachment ? 'is-ready' : ''}`}>

          { this.props.image.uploading &&
            <div className="brew-image__loader">
              <div className="brew-image__bar">
                <div className="brew-image__progress" style={{width: `${ this.props.image.progress }%` }}></div>
              </div>
            </div>
          }

          { this.props.image.attachment &&
            <img className="brew-image__preview" src={ this.props.image.attachment.preview.url } alt=""/>
          }

          <img
            className="brew-image__download"
            src={ this.props.image.url ? this.props.image.url : '' }
            onLoad={ () => this.props.handleImageLoaded(this.props.image.refPath) }
            alt=""
          />

        </div>
      )
    }
  }
}

export default Image;
